import { forIn, set } from 'lodash';
import { get } from '../../../../shared/utils/functional/get';
import app from '../app';

import { itemsByCategory as buildingTypeItemsByCategory } from '../enums/building-type';
import saleResidentialObjectTypes from '../enums/sale-residential-object-types';
import rentResidentialObjectTypes from '../enums/rent-residential-object-types';
import dailyRentResidentialObjectTypes from '../enums/daily-rent-residential-object-types';
import commercialObjectTypes, { businessSubTypes } from '../enums/commercial-object-types';
import { addressChanged } from '../../blocks/segments/address/address.events';
import { isObjectSplits } from '../../../../shared/utils';
import { getCoworkingSubTypes } from '../../../../shared/utils/coworking/getCoworkingSubTypes';

export const selfEmployedUpdated = 'addForm.selfEmployedUpdated';

// объект ad всегда один, надо свести к минимуму передачу его как параметра и в виде байндинга (каждый байндинг добавляет два вотчера
app.service('addFormService', [
  '$rootScope',
  'categoryService',
  '$window',
  'getAddFormMetaService',
  function ($rootScope, categoryService, $window, getAddFormMetaService) {
    this.ad = null;
    this.form = null;
    this.selfEmployed = { ...window.addFormState.selfEmployed };
    this.needHideRestForm = () => {};

    // установить автоматическое заполнение одних полей при изменении других
    // большинство таких связей сейчас находится в контроллерах директив-полей - это не работает в случае короткой формы,
    // когда эти поля актуальны, но не показаны на форме
    this.setupDependentFields = () => {
      setBuildingTypeByCateogryAndPlacementType();
      setAccountTypeByJK();
    };

    const setAccountTypeByJK = () => {
      // eslint-disable-next-line no-unused-vars
      $rootScope.$watchGroup(
        [() => get(this, 'ad.isByHomeowner'), () => get(this, 'ad.geo.jk.id')],
        ([, jkId], [, oldJkId]) => {
          if (!jkId || jkId === oldJkId) {
            return;
          }
          if (!this.isCplNewbuildingSelected()) {
            this.ad.cplModeration = undefined;
          }
        },
      );
    };
    const setBuildingTypeByCateogryAndPlacementType = () => {
      $rootScope.$watchGroup(
        [() => this.ad.category, () => this.ad.placementType],
        ([category, placementType], [oldCategory, oldPlacementType]) => {
          if (!category || (category === oldCategory && placementType === oldPlacementType)) {
            return;
          }

          const { objectType, propertyType } = categoryService.getInfoByCategory(category);
          let categoryKey;

          if (propertyType === 'commercial') {
            categoryKey = propertyType;
          } else {
            categoryKey = objectType;
          }

          if (!this.ad.building) {
            this.ad.building = {};
          }

          const categoryConfig = buildingTypeItemsByCategory[categoryKey];
          if (categoryConfig) {
            this.ad.building.type = categoryConfig && categoryConfig.defaultValue;
          }

          this.selfEmployedUpdate();
        },
      );
    };

    this.provideForm = form => {
      this.form = form;
    };

    const setFieldValue = (field, value) =>
      angular.isFunction(field.tryToSetValue) ? field.tryToSetValue(value) : field.$setViewValue(value);

    /**
     * Заполняет форму не через модель, а через поле, по названию name тега input
     * Если поля нет на форме, значения не будет в ad
     * Объект должен быть плоским, пример
     * {
     *   'building.buildYear': '1960'
     * }
     * @param  {Object} obj объект {[название поля]: [значение]}
     */
    this.fillForm = obj => {
      if (this.form === null) {
        return;
      }

      // Россия, Москва, Усачёва улица, 62
      forIn(obj, (value, key) => {
        const field = this.form[key];

        if (field) {
          if (value === null) {
            // TODO нужно обсудить, как должна себя вести форма, когда приходит значение null
            setFieldValue(field, undefined);
          } else {
            setFieldValue(field, value);
          }

          field.$render();
        }
      });
    };

    this.cleanFormIfEqual = function (obj) {
      if (this.form === null) {
        return;
      }
      forIn(obj, (value, key) => {
        const field = get(this.form, key);
        if (field) {
          if (value !== null) {
            // TODO нужно обсудить, как должна себя вести форма, когда очищаем те данные, где пришло null
            setFieldValue(field, undefined);
          }
          field.$render();
        }
      });
    };

    /**
     * blockingActions
     * Массив строк, с действиями из-за которых кнопка отправки формы будет заблокирована
     */
    const blockingActions = [];

    this.addBlockingAction = actionName => {
      if (blockingActions.indexOf(actionName) === -1) {
        blockingActions.push(actionName);
      }
    };

    this.removeBlockingAction = actionName => {
      const blockingActionIndex = blockingActions.indexOf(actionName);

      if (blockingActionIndex !== -1) {
        blockingActions.splice(blockingActionIndex, 1);
      }
    };

    this.hasBlockingActions = () => blockingActions.length;

    this.isJkCategory = () => this.ad.category === 'newBuildingFlatSale';

    this.isJkSecondaryCategory = () => this.ad.category === 'flatSale';

    this.isCplNewbuildingSelected = () =>
      get($window, 'addFormState.cplNewbuildingsIds', []).includes(get(this, 'ad.geo.jk.id'));

    this.isCoworkingObject = () => !!this.ad?.coworkingOfferType;
    this.isBusinessObject = () => !!this.ad?.readyBusinessType;

    const getObjectTypes = (propertyType, dealType, rentDuration) => {
      if (propertyType === 'commercial') {
        if (this.isCoworkingObject()) {
          return getCoworkingSubTypes();
        }

        if (this.isBusinessObject()) {
          return businessSubTypes;
        }

        return commercialObjectTypes;
      }
      if (propertyType === 'residential' && dealType === 'sale') {
        return saleResidentialObjectTypes;
      }
      if (propertyType && rentDuration === 'short') {
        return dailyRentResidentialObjectTypes;
      }
      if (propertyType && rentDuration) {
        return rentResidentialObjectTypes;
      }

      return null;
    };

    this.getOfferShortTitle = () => {
      const { propertyType, dealType, rentDuration, objectType } = categoryService.getInfoByCategory(
        get(this.ad, 'category'),
      );
      const objectTypes = getObjectTypes(propertyType, dealType, rentDuration);
      if (!objectTypes) {
        return;
      }
      const selectedObjectType = objectTypes.find(item => {
        if (this.isCoworkingObject()) {
          return item.key === this.ad.coworkingOfferType;
        }

        if (this.isBusinessObject()) {
          return item.key === this.ad.readyBusinessType;
        }

        return item.key === objectType;
      });

      const title = [];
      title.push(dealType === 'rent' ? 'Аренда' : 'Продажа');

      if (this.ad.isRentByParts) {
        title.push('части дома');
      } else if (selectedObjectType) {
        title.push(selectedObjectType.genitiveName.toLowerCase());
      }
      if (rentDuration && rentDuration === 'short') {
        title.push('посуточно');
      }

      return title.join(' ');
    };

    this.selfEmployedUpdate = () => {
      getAddFormMetaService.run(this.ad).then(({ selfEmployed }) => {
        this.selfEmployed = selfEmployed;
      });
    };

    this.getSelfEmployed = () => this.selfEmployed;

    this.isObjectSplits = () => isObjectSplits(this.ad);

    this.initCoworkingField = () => {
      if (!this.ad) {
        this.ad = {};
      }

      this.ad.coworking = {};
    };

    this.setValueByPath = (pathToField, value) => set(this.ad, pathToField, value);

    this.isFieldExisted = name => !!get(this.ad, name);

    this.getFieldValue = (name, defaultValue = undefined) => get(this.ad, name, defaultValue);

    this.isEditMode = () => !!get(this.ad, 'id');

    this.provideNeedHideRestForm = needHideRestFormFunction => {
      this.needHideRestForm = needHideRestFormFunction;
    };

    $rootScope.$on(addressChanged, this.selfEmployedUpdate);
    $rootScope.$watch(() => get(this, 'ad.isByHomeowner'), this.selfEmployedUpdate);
  },
]);
